import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { AuthData } from "auth/AuthWarpper"; // get user info
import styled from "@emotion/styled";
import lockperson from "assets/user-access/lockperson.svg";

const LockedUser = ({
  heading = "Account Locked",
}) => {
  const { user } = AuthData();
  const days = user?.lockDays // fallback if undefined

  const messageLines = [
    `Your account has been locked in the Agri360 application due to ${days} days of inactivity.`,
    "To unlock your account, please contact your local admin for assistance"
  ];

  const RainbowContainer = styled.div`
  background: linear-gradient(
      90deg,
      #0e2b63 30.4785%,
      rgba(0, 0, 0, 0) 30.4785%
    ),
    linear-gradient(90deg, #004f9f 52.15788%, rgba(0, 0, 0, 0) 52.15788%),
    linear-gradient(90deg, #00b1eb 64.72807%, rgba(0, 0, 0, 0) 64.72807%),
    linear-gradient(90deg, #ef7d00 73.22551%, rgba(0, 0, 0, 0) 73.22551%),
    linear-gradient(90deg, #ffbb00 79.62792%, rgba(0, 0, 0, 0) 79.62792%),
    linear-gradient(90deg, #50af47 86.69237%, rgba(0, 0, 0, 0) 86.69237%),
    linear-gradient(90deg, #afca0b 92.0305%, rgba(0, 0, 0, 0) 92.0305%),
    linear-gradient(90deg, #5a328a 97.0083%, rgba(0, 0, 0, 0) 97.0083%),
    linear-gradient(90deg, #e72582 100%, rgba(0, 0, 0, 0) 100%);
  height: 1.5rem;
`;
  const FooterContainer = styled.div`
  position: fixed;
  bottom: 0;
  background: #112a63;
  height: 3.5rem;
  width: calc(100vw + 60px);
  z-index:1;
`;

  return (
    <>
      <Box sx={{ width: "calc(100vw - 60px)", height: "calc(100vh - 24px)", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            padding: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "Center",
            backgroundColor: "#enebf0",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "Center",
              backgroundColor: "#F5F7FA",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",

              borderRadius: "8px",
              boxSizing: "border-box"
            }}
          >
            <Paper
              elevation={0}
              sx={{
                width: 380,
                padding: "40px 36px 36px",
                borderRadius: "4px",
                border: "1px solid #E7E8EB",
                textAlign: "center",
                backgroundColor: "#FFFFFF",
                fontFamily: "Montserrat"
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",

                }}
              >
                <img src={lockperson} alt="locked person" style={{ width: "96px", height: "88px" }} />
              </Box>

              <Typography
                sx={{
                  fontFamily: "Montserrat",
                  fontWeight: 600,
                  fontSize: "20px",
                  color: "#0D356E",
                  mb: 2
                }}
              >
                {heading}
              </Typography>

              {messageLines.map((line, i) => (
                <Typography
                  key={i}
                  sx={{
                    fontFamily: "Montserrat",
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "#0D356E",
                    mb: i === messageLines.length - 1 ? 0 : 1
                  }}
                >
                  {line}
                </Typography>
              ))}
            </Paper>

          </Box>
        </Box>
      </Box>
      <RainbowContainer />
    </>

  );
};





export default LockedUser;